import { FC } from 'react'
import DeactivateNotificationIntegration from '@/components/modals/DeactivateNotificationIntegration'

interface DeactivateMaxNotificationBotProps {
  open?: boolean
  setOpen?: (open: boolean) => void
  integrationId?: number | null
  displayHandle?: string | null
}

const DeactivateMaxNotificationBot: FC<DeactivateMaxNotificationBotProps> = (props) => (
  <DeactivateNotificationIntegration provider="max" {...props} />
)

export default DeactivateMaxNotificationBot
